import React, { memo } from 'react';
import { NewSearch } from '../../NewSearch';
import { PopularRequests } from '../../PopularRequests';
import { HomeLayoutWithBanner } from '../../HomeLayoutWithBanner';
import useScreenSize from '../../../hooks/useScreenSize';
import { usePopState } from '../../../hooks/usePopState';
import { ResidencesSection } from '../../Sections/ResidencesSection';
import { AgenciesSection } from '../../Sections/AgenciesSection';
import { FeaturedItemsSection } from '../../Sections/FeaturedItemsSection';
import { useFirstInteraction } from '../../../hooks/useFirstInteraction';
import { BannerSlot } from '../../Banner/BannerSlot';
import { BannerPlacement } from '../../../utils/constants/banners';
import { useBookmarks } from '../../../hooks/useBookmarks';

const HomePage: React.FC = () => {
  const { isSmall } = useScreenSize();
  const { isPopState } = usePopState();
  const { isBookmarked } = useBookmarks();
  const shouldLoadBanner = useFirstInteraction();
  const showMobileTopBanner = !isPopState && isSmall && shouldLoadBanner;

  return (
    <>
      <NewSearch isHomePage />
      <HomeLayoutWithBanner shouldLoadBanner={shouldLoadBanner}>
        <ResidencesSection />
        {showMobileTopBanner && (
          <BannerSlot placement={BannerPlacement.MobileTop} />
        )}
        <AgenciesSection isBookmarked={isBookmarked} />
        <FeaturedItemsSection
          isPopState={isPopState}
          isBookmarked={isBookmarked}
        />
        <PopularRequests />
      </HomeLayoutWithBanner>
    </>
  );
};

export default memo(HomePage);
